import {
  Control,
  FieldErrors,
  UseFormRegister,
  Controller,
} from "react-hook-form";
import { TCreateCOSHH } from "../types";
import { Input } from "~/components/ui";
import { cn } from "~/lib/utils";
import { FormSelectInput, FormDateInput } from "~/components/form-inputs";

interface Props {
  control: Control<TCreateCOSHH>;
  register: UseFormRegister<TCreateCOSHH>;
  errors: FieldErrors<TCreateCOSHH>;
}

const HeaderStep = ({ control, errors, register }: Props) => {
  return (
    <div className="flex flex-col gap-6 w-full space-y-6 rounded-xl border border-neutral-200 bg-white p-8">
      <div className="grid grid-cols-2 gap-6 w-full">
        <div className="space-y-2">
          <label className="text-sm font-medium">Reference</label>
          <Input
            {...register("reference")}
            readOnly
            className="bg-neutral-100 cursor-not-allowed text-neutral-500"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">
            Title<span className="text-destructive ml-1">*</span>
          </label>
          <Input
            {...register("title")}
            placeholder="Enter Title"
            className={cn(errors.title && "border-destructive")}
          />
          {errors.title?.message && (
            <p className="text-destructive text-sm">
              {errors.title.message.toString()}
            </p>
          )}
        </div>
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium">Description</label>
        <textarea
          {...register("description")}
          placeholder="Enter description"
          className={cn(
            "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            errors.description && "border-destructive",
          )}
        />
        {errors.description?.message && (
          <p className="text-destructive text-sm">
            {errors.description.message.toString()}
          </p>
        )}
      </div>

      <div className="grid grid-cols-2 gap-6 w-full">
        <div className="space-y-2">
          <Controller
            control={control}
            name="siteId"
            render={({ field: { onChange, value } }) => (
              <FormSelectInput
                label="Site"
                options={[]}
                placeholder="Select Site"
                isMulti={false}
                value={value || undefined}
                onChange={onChange}
                errors={{
                  error: !!errors.siteId,
                  message: errors.siteId?.message?.toString(),
                }}
              />
            )}
          />
        </div>

        <div className="space-y-2">
          <Controller
            control={control}
            name="assessmentDate"
            render={({ field: { onChange, value } }) => (
              <FormDateInput
                label="Assessment Date"
                value={value ? value.toISOString() : undefined}
                onChange={(val) => onChange(val ? new Date(val) : null)}
                errors={{
                  error: !!errors.assessmentDate,
                  message: errors.assessmentDate?.message?.toString(),
                }}
              />
            )}
          />
        </div>

        <div className="space-y-2">
          <Controller
            control={control}
            name="nextReviewDate"
            render={({ field: { onChange, value } }) => (
              <FormDateInput
                label="Next Review Date"
                value={value ? value.toISOString() : undefined}
                onChange={(val) => onChange(val ? new Date(val) : null)}
                errors={{
                  error: !!errors.nextReviewDate,
                  message: errors.nextReviewDate?.message?.toString(),
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderStep;
